import { Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';

import { Origem, OrigemID } from '../../domain';

interface Config {
    isCampanha: boolean;
    isIndicacao: boolean;
    isMidiaSocial: boolean;
    isPesquisaOrganica: boolean;
    isProspeccaoAtiva: boolean;
    isSite: boolean;
    isValid?: boolean;
}

@Component({
    selector: 'sgt-origem-select',
    templateUrl: './origem-select.component.html',
    styleUrls: ['./origem-select.component.less']
})
export class OrigemSelectComponent implements OnInit {
    config: Config;

    /** Opções de origens disponíveis para seleção */
    @Input() origensOptions: Origem[] = Origem.getAll();

    /** Origem */
    @Input() idOrigem: number;
    /** Ao alterar a origem */
    @Output() idOrigemChange = new EventEmitter<number>();
    /** Origem selecionada */
    origem: Origem;
    /** Origem alterada */
    @Output() origemChange = new EventEmitter<Origem>();

    /** Se deve desabilitar o input */
    @Input() disabled: boolean;

    /** Se se a origem é obrigatória */
    @Input() required = false;

    @ViewChild('dropdownToggle') dropdownToggle: ElementRef;

    ngOnInit(): void {
        this.origem = this.getOrigem(this.idOrigem);
        this.setConfig();
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'idOrigem' && !changes[propName].isFirstChange()) {
                this.origem = this.getOrigem(this.idOrigem);
                this.setIsValid();
            } else if (propName === 'required') {
                this.setIsValid();
            }
        }
    }

    /** Obtem a origem através do ID */
    private getOrigem(idOrigem: number): Origem {
        if (!idOrigem || !this.origensOptions) {
            return null;
        }
        return this.origensOptions.find(origemFilter => origemFilter.id === idOrigem);
    }

    /** Ao selecionar a origem */
    select(origem: Origem) {
        this.idOrigem = origem ? origem.id : null;
        this.idOrigemChange.emit(this.idOrigem);
        this.origem = origem;
        this.origemChange.emit(this.origem)

        this.setConfig();
    }

    /** Seta as configs. do select */
    private setConfig() {
        this.config = {
            isCampanha: OrigemID.isOrigemCampanha(this.idOrigem),
            isIndicacao: OrigemID.isOrigemIndicacao(this.idOrigem),
            isMidiaSocial: OrigemID.isOrigemMidiaSocial(this.idOrigem),
            isPesquisaOrganica: OrigemID.isOrigemPesquisaOrganica(this.idOrigem),
            isProspeccaoAtiva: OrigemID.isOrigemProspeccaoAtiva(this.idOrigem),
            isSite: OrigemID.isOrigemSite(this.idOrigem)
        }
        this.setIsValid();
    }

    private setIsValid() {
        if (!this.config) {
            return;
        }

        // Obrigatório e não selecionada a origem
        if (this.required && !this.idOrigem) {
            this.config.isValid = false;
            return;
        }

        this.config.isValid = true;
    }

    get isValid(): boolean {
        return this.config.isValid;
    }

    /** Seta foco no select */
    setFocus() {
        jQuery(this.dropdownToggle?.nativeElement).trigger('focus');
    }
}
